import {
  createContext,
  FC,
  ReactNode,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useMsal } from "@azure/msal-react";
import { AccountInfo } from "@azure/msal-browser";
import { MsalUser } from "./MsalUser";
import { User, UserContext } from "shared-ts-utils-authentication";

interface AccountInfoContextType {
  account: AccountInfo;
}

export const AccountInfoContext = createContext({} as AccountInfoContextType);

export interface AccountInfoContextProviderProps {
  children?: ReactNode | ((user: User) => ReactNode);
}

export const AccountInfoContextProvider: FC<AccountInfoContextProviderProps> = (
  props
) => {
  const { accounts } = useMsal();
  const [account, setAccount] = useState<AccountInfo | null>(null);
  const [user, setUser] = useState<User | null>(null);
  const contextValue = useMemo(() => ({ account: account }), [account]);

  useEffect(() => {
    if (accounts.length > 0) {
      setAccount(accounts[0]);
      setUser(new MsalUser(accounts[0]));
    }
  }, [accounts]);

  if (contextValue.account == null || user == null) {
    return null;
  }

  return (
    <AccountInfoContext.Provider value={contextValue as AccountInfoContextType}>
      <UserContext.Provider value={user}>
        {typeof props.children === "function"
          ? props.children(user)
          : props.children}
      </UserContext.Provider>
    </AccountInfoContext.Provider>
  );
};
